// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, computed, input } from '@angular/core';
import { Location as LocationEntity } from '../../../entities/location/location';

@Component({
  selector: 'app-issue-location-updated',
  template: `
    <ng-container *ngIf="location(); else noLocation">
    <b>{{activity()?.actor?.displayName}}</b> hat die Niederlassung zu <b>{{location()?.name}}</b> geändert <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-container>
    <ng-template #noLocation>
      <b>{{activity()?.actor?.displayName}}</b> hat die Niederlassung entfernt <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-template>
  `
})
export class IssueLocationUpdatedComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();

  readonly location = computed(() => {
    const activity = this.activity();
    if (activity?.viewModel?.newLocation) {
      return new LocationEntity(activity.viewModel.newLocation);
    }
    return undefined;
  });
}
